import React from "react";
import { inject, observer } from "mobx-react";
import { Modal, Table, Button } from "react-bootstrap";
import ListSearch from "../bucket/ListSearch";
import { Link } from "react-router-dom";
import CellContent from "../vis/template/CellContent";
import toastService from "../../services/ToastService";
import "./CubeLinkVariables.scss";
import { StoreContext } from "../../contexts/StoreContext";

@inject("memberLinkViewStore")
@inject("detailViewStore")
@observer
export class CubeLinkVariables extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: undefined,
      showModal: false,
      title: undefined,
      foreignTitle: undefined,
      primaryTitle: undefined,
      primaryCubes: undefined,
      foreignCubes: undefined,
      isEnumerated: false,
      showEqualMembers: false,
      combinationJson: "",
      combinationCode: "",
      isCombinationJsonValid: false,
      primaryVariableCombinationFilter: "",
      applyFilterOnlyForPrimaryMembers: true,
    };
  }

  helper_closeModal() {
    const { clearEntityData } = this.props.memberLinkViewStore;

    this.setState({
      showModal: !this.state.showModal,
      items: undefined,
      title: undefined,
      isEnumerated: false,
      foreignTitle: undefined,
      primaryTitle: undefined,
      primaryCubes: undefined,
      foreignCubes: undefined,
      showEqualMembers: false,
      primaryVariableCombinationFilter: "",
      applyFilterOnlyForPrimaryMembers: true,
    });
    this.props.detailViewStore.setSearchMatrix(this.props.searchMatrixKey, "");
    clearEntityData();
  }

  componentDidMount() {
    this.props.detailViewStore.setSearchMatrix(this.props.searchMatrixKey, "");
  }

  helper_findHeader(item) {
    let primaryCube = "";
    let foreignCube = "";
    let primaryFramework = "";
    let foreignFramework = "";

    if (
      item &&
      item.item &&
      item.item.navigationLookupResult &&
      item.item.navigationLookupResult.navigationLookupBuckets &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Cubes"
      ] &&
      item.item.navigationLookupResult.navigationLookupBuckets["Primary Cubes"]
        .objects &&
      item.item.navigationLookupResult.navigationLookupBuckets &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Cubes"
      ] &&
      item.item.navigationLookupResult.navigationLookupBuckets["Foreign Cubes"]
        .objects &&
      item.item.navigationLookupResult.navigationLookupBuckets &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Frameworks"
      ] &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Frameworks"
      ].objects &&
      item.item.navigationLookupResult.navigationLookupBuckets &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Frameworks"
      ] &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Frameworks"
      ].objects
    ) {
      primaryCube = item.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Cubes"
      ].objects.find(
        (cube) =>
          cube.cubeId ===
          item.item.navigationLookupResult.navigationLookupRootItem.object
            .primaryCubeId
      );
      foreignCube = item.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Cubes"
      ].objects.find(
        (cube) =>
          cube.cubeId ===
          item.item.navigationLookupResult.navigationLookupRootItem.object
            .foreignCubeId
      );
      primaryFramework =
        item.item.navigationLookupResult.navigationLookupBuckets[
          "Primary Frameworks"
        ].objects[0];
      foreignFramework =
        item.item.navigationLookupResult.navigationLookupBuckets[
          "Foreign Frameworks"
        ].objects[0];
    }
    const result = {
      primaryCube: primaryCube,
      primaryFramework: primaryFramework,
      foreignCube: foreignCube,
      foreignFramework: foreignFramework,
    };
    return result;
  }

  helper_findVariables(item) {
    const result = [];
    if (
      item &&
      item.item &&
      item.item.navigationLookupResult &&
      item.item.navigationLookupResult.navigationLookupBuckets &&
      item.item.navigationLookupResult.navigationLookupBuckets["CSI Link"] &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Variables"
      ] &&
      item.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Variables"
      ]
    ) {
      let cubeStructureItemLinks =
        item.item.navigationLookupResult.navigationLookupBuckets["CSI Link"];
      cubeStructureItemLinks.objects.forEach((cubeStructureItemLink) => {
        const variable = {
          primaryVariable:
            item.item.navigationLookupResult.navigationLookupBuckets[
              "Primary Variables"
            ].objects.filter((variable) => {
              return (
                variable.code === cubeStructureItemLink.primaryCubeVariableCode
              );
            }),
          foreignVariable:
            item.item.navigationLookupResult.navigationLookupBuckets[
              "Foreign Variables"
            ].objects.filter((variable) => {
              return (
                variable.code === cubeStructureItemLink.foreignCubeVariableCode
              );
            }),
          tid: cubeStructureItemLink.tid,
          type: cubeStructureItemLink.type,
        };
        variable.primaryVariable.length > 0 &&
          variable.foreignVariable.length > 0 &&
          result.push(variable);
      });
    }
    return result;
  }

  helper_renderModal(data, item, header) {
    const { clearEntityData, fetchEntityDetailsWithoutCallback } =
      this.props.memberLinkViewStore;

    clearEntityData();

    if (
      data &&
      data.item &&
      data.item.navigationLookupResult &&
      data.item.navigationLookupResult.navigationLookupBuckets &&
      data.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Domains"
      ] &&
      data.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Domains"
      ]
    ) {
      const primaryDomains =
        data.item.navigationLookupResult.navigationLookupBuckets[
          "Primary Domains"
        ].objects;
      const foreignDomains =
        data.item.navigationLookupResult.navigationLookupBuckets[
          "Foreign Domains"
        ].objects;

      const primaryDomainsEnumerated =
        primaryDomains.filter(
          (domain) =>
            domain.domainId === item.primaryVariable[0].domainId &&
            domain.isEnumerated
        ).length > 0;
      const foreignDomainsEnumerated =
        foreignDomains.filter(
          (domain) =>
            domain.domainId === item.foreignVariable[0].domainId &&
            domain.isEnumerated
        ).length > 0;

      if (primaryDomainsEnumerated && foreignDomainsEnumerated) {
        this.setState({
          isEnumerated: true,
        });
      }
    }

    const primaryTitle = `${header.primaryCube.name}.${item.primaryVariable[0].name} (${item.primaryVariable[0].code})`;
    const foreignTitle = `${header.foreignCube.name}.${item.foreignVariable[0].name} (${item.foreignVariable[0].code})`;
    this.setState({
      showModal: true,
      primaryTitle: primaryTitle,
      foreignTitle: foreignTitle,
      primaryVariableCombinationFilter: item.primaryVariable[0].code,
    });
    fetchEntityDetailsWithoutCallback(item.type, item.tid);
  }

  helper_renderModalData = () => {
    const { getEntityData } = this.props.memberLinkViewStore;
    const data = getEntityData;
    const memberPairs = [];

    const variableList =
      this.state.combinationJson &&
      this.state.combinationJson.filter(
        (x) => x.variableId === this.state.primaryVariableCombinationFilter
      );
    const variable = variableList && variableList[0];

    if (
      data &&
      data.item &&
      data.item.navigationLookupResult &&
      data.item.navigationLookupResult.navigationLookupBuckets &&
      data.item.navigationLookupResult.navigationLookupBuckets[
        "Member Links"
      ] &&
      data.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Member Links"
      ] &&
      data.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Member Links"
      ]
    ) {
      const memberLinks =
        data.item.navigationLookupResult.navigationLookupBuckets["Member Links"]
          .objects;
      const primaryMembers =
        data.item.navigationLookupResult.navigationLookupBuckets[
          "Primary Member Links"
        ].objects;
      const foreignMembers =
        data.item.navigationLookupResult.navigationLookupBuckets[
          "Foreign Member Links"
        ].objects;

      memberLinks.forEach((item) => {
        const relatedPrimaryMember = primaryMembers.find(
          (primaryMember) => primaryMember.memberId === item.primaryMemberId
        );
        const relatedForeignMember = foreignMembers.find(
          (foreignMember) => foreignMember.memberId === item.foreignMemberId
        );
        if (relatedPrimaryMember && relatedForeignMember) {
          let primaryMember = relatedPrimaryMember;
          primaryMember.isLinked = item.isLinked;
          let foreignMember = relatedForeignMember;
          foreignMember.isLinked = item.isLinked;
          const member = {
            primaryMember,
            foreignMember,
          };
          if (this.state.combinationJson) {
            if (
              variable &&
              member.primaryMember.code === variable.member.code
            ) {
              memberPairs.push(member);
            }
          } else {
            memberPairs.push(member);
          }
        }
      });
    }
    return memberPairs;
  };

  helper_renderDataForQueryWizard = (entityData, item) => {
    const variableList =
      this.state.combinationJson &&
      this.state.combinationJson.filter(
        (x) => x.variableId === item.primaryVariable[0].code
      );
    const variable = variableList && variableList[0];
    const memberIds = [];
    if (
      entityData &&
      entityData.item &&
      entityData.item.navigationLookupResult &&
      entityData.item.navigationLookupResult.navigationLookupBuckets &&
      entityData.item.navigationLookupResult.navigationLookupBuckets[
        "Member Links"
      ] &&
      entityData.item.navigationLookupResult.navigationLookupBuckets[
        "Primary Member Links"
      ] &&
      entityData.item.navigationLookupResult.navigationLookupBuckets[
        "Foreign Member Links"
      ]
    ) {
      const memberLinks =
        entityData.item.navigationLookupResult.navigationLookupBuckets[
          "Member Links"
        ].objects;
      const primaryMembers =
        entityData.item.navigationLookupResult.navigationLookupBuckets[
          "Primary Member Links"
        ].objects;
      const foreignMembers =
        entityData.item.navigationLookupResult.navigationLookupBuckets[
          "Foreign Member Links"
        ].objects;

      memberLinks.forEach((it) => {
        const relatedPrimaryMember = primaryMembers.find(
          (primaryMember) => primaryMember.memberId === it.primaryMemberId
        );
        const relatedForeignMember = foreignMembers.find(
          (foreignMember) => foreignMember.memberId === it.foreignMemberId
        );
        if (this.state.combinationJson) {
          if (
            variable &&
            relatedPrimaryMember &&
            relatedForeignMember &&
            relatedPrimaryMember.code === variable.member.code
          ) {
            memberIds.push(relatedForeignMember.memberId);
          }
        }
      });
    }
    return memberIds;
  };

  handleShowEqualMembers = () => {
    this.setState({
      showEqualMembers: !this.state.showEqualMembers,
    });
  };

  createQueryWizardFilterObject = (e, variablesList) => {
    const {
      clearEntityData,
      getAsyncEntityData,
      fetchEntityDetailsWithoutCallback,
    } = this.props.memberLinkViewStore;

    const {
      toggleOpenFromCubeLinkPage,
      extractMembersFromMemberLinks,
      resetDefaultFiltersFromMemberLinks,
    } = this.props.cubeQueryWizardStore;

    clearEntityData();
    resetDefaultFiltersFromMemberLinks();

    variablesList.forEach(async (item) => {
      await fetchEntityDetailsWithoutCallback(item.type, item.tid);
      const entityData = await getAsyncEntityData();
      clearEntityData();
      if (entityData && entityData.item) {
        const memberIds = this.helper_renderDataForQueryWizard(
          entityData,
          item
        );
        const element = {};
        element.code = item.foreignVariable[0].code;
        element.memberIds = Array.from(new Set(memberIds));
        memberIds.length > 0 && extractMembersFromMemberLinks(element);
      }
    });
    toggleOpenFromCubeLinkPage(true);
  };

  pasteHandler = (event) => {
    let json = "";
    try {
      json = JSON.parse(event.clipboardData.getData("text"));
      const isEqual =
        JSON.stringify(Object.keys(json)) === JSON.stringify(["name", "value"]);
      if (!isEqual) {
        throw new Error();
      }
      this.setState({
        isCombinationJsonValid: true,
        combinationJson: json.value,
        combinationCode: json.name,
      });
    } catch (e) {
      toastService.func_notify(
        "Wrong format of provided string",
        "error"
      );
    }
    event.preventDefault();
  };

  clearCombinationFilter = () => {
    this.setState({
      combinationJson: "",
      combinationCode: "",
      isCombinationJsonValid: false,
      primaryVariableCombinationFilter: "",
    });
  };
  handleApplyFilterOnlyForForeignMembers = () => {
    this.setState({
      applyFilterOnlyForPrimaryMembers:
        !this.state.applyFilterOnlyForPrimaryMembers,
    });
  };
  static contextType = StoreContext;
  render() {
    const { detailViewStore, searchMatrixKey } = this.props;
    const { getEntityData } = this.props.detailViewStore;
    const variablesList = this.helper_findVariables(getEntityData);
    const modalData = this.helper_renderModalData();
    const header = this.helper_findHeader(getEntityData);
    const searchExpr = detailViewStore.getSearchMatrix[searchMatrixKey] || "";

    const filteredModalData = modalData.filter((item) => {
      if (searchExpr) {
        const primaryNamesInNestedObjects = item.primaryMember.name
          ? item.primaryMember.name.toLowerCase()
          : "";
        const primaryCodesInNestedObjects = item.primaryMember.code
          ? item.primaryMember.code.toLowerCase()
          : "";
        const foreignNamesInNestedObjects = item.foreignMember.name
          ? item.foreignMember.name.toLowerCase()
          : "";
        const foreignCodesInNestedObjects = item.foreignMember.code
          ? item.foreignMember.code.toLowerCase()
          : "";
        if (this.state.applyFilterOnlyForPrimaryMembers) {
          return (
            primaryNamesInNestedObjects.includes(searchExpr.toLowerCase()) ||
            primaryCodesInNestedObjects.includes(searchExpr.toLowerCase())
          );
        } else {
          return (
            primaryNamesInNestedObjects.includes(searchExpr.toLowerCase()) ||
            primaryCodesInNestedObjects.includes(searchExpr.toLowerCase()) ||
            foreignNamesInNestedObjects.includes(searchExpr.toLowerCase()) ||
            foreignCodesInNestedObjects.includes(searchExpr.toLowerCase())
          );
        }
      } else {
        return true;
      }
    });

    const filteredEqualMembers = filteredModalData.filter((item) => {
      if (this.state.showEqualMembers) {
        return item.primaryMember.memberId === item.foreignMember.memberId;
      } else {
        return true;
      }
    });

    const isLoaded =
      !!header?.primaryCube &&
      !!header?.foreignCube &&
      !!header?.primaryFramework &&
      !!header?.foreignFramework;

    return (
      <div className="related-objects custom-panel">
        <div className="custom-panel-heading">
          <div style={{ display: "flex" }}>
            <h4>How to link the Cubes</h4>
            {!isLoaded ? (
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {isLoaded ? (
          <>
            <div className="custom-panel-body related-types-list">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "10px",
                }}
              >
                <input
                  defaultValue={this.state.combinationCode}
                  disabled={this.state.isCombinationJsonValid}
                  className="form-control"
                  tabIndex={-1}
                  onPaste={this.pasteHandler}
                  placeholder="Paste the Combination JSON ..."
                  style={{ maxWidth: 400 }}
                ></input>
                <Button
                  bsClass="btn btn-default"
                  style={{ marginBottom: 10 }}
                  onClick={this.clearCombinationFilter}
                >
                  Clear Filter
                </Button>
              </div>
            </div>
            <div className="custom-panel-body">
              <div className="item-list-container">
                <Table hover className="mapping-definition-table">
                  <thead>
                    <tr>
                      <td>
                        <div>
                          <div>
                            <Link
                              className="object-name"
                              to={`/view/${header.primaryFramework.type}/${header.primaryFramework.tid}`}
                            >
                              {header.primaryFramework.name ? (
                                <CellContent
                                  maxLength={60}
                                  content={header.primaryFramework.name}
                                  id={0}
                                />
                              ) : (
                                "->"
                              )}
                            </Link>
                          </div>
                          <div>
                            <Link
                              className="object-name"
                              to={`/view/${header.primaryCube.type}/${header.primaryCube.tid}`}
                            >
                              {header.primaryCube.name ? (
                                <CellContent
                                  maxLength={60}
                                  content={header.primaryCube.name}
                                  id={0}
                                />
                              ) : (
                                "->"
                              )}
                            </Link>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div>
                          <div>
                            <Link
                              className="object-name"
                              to={`/view/${header.foreignFramework.type}/${header.foreignFramework.tid}`}
                            >
                              {header.foreignFramework.name ? (
                                <CellContent
                                  maxLength={60}
                                  content={header.foreignFramework.name}
                                  id={0}
                                />
                              ) : (
                                "->"
                              )}
                            </Link>
                          </div>
                          <div>
                            <Link
                              className="object-name"
                              to={`/view/${header.foreignCube.type}/${header.foreignCube.tid}`}
                            >
                              {header.foreignCube.name ? (
                                <CellContent
                                  maxLength={60}
                                  content={header.foreignCube.name}
                                  id={0}
                                />
                              ) : (
                                "->"
                              )}
                            </Link>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {variablesList.length
                      ? variablesList
                          .sort((a, b) =>
                            a.primaryVariable[0].code.localeCompare(
                              b.primaryVariable[0].code
                            )
                          )
                          .map((item, index) => (
                            <tr
                              key={index}
                              onClick={() =>
                                this.helper_renderModal(
                                  getEntityData,
                                  item,
                                  header
                                )
                              }
                            >
                              <td>
                                {item.primaryVariable[0].name &&
                                item.primaryVariable[0].code ? (
                                  <CellContent
                                    maxLength={60}
                                    content={`${item.primaryVariable[0].name} (${item.primaryVariable[0].code})`}
                                    id={0}
                                  />
                                ) : (
                                  "->"
                                )}
                              </td>
                              <td>
                                {item.foreignVariable[0].name &&
                                item.foreignVariable[0].code ? (
                                  <CellContent
                                    maxLength={60}
                                    content={`${item.foreignVariable[0].name} (${item.foreignVariable[0].code})`}
                                    id={0}
                                  />
                                ) : (
                                  "->"
                                )}
                              </td>
                            </tr>
                          ))
                      : "Nothing found"}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        <div>
          <Modal
            size="lg"
            dialogClassName="LinkVariables"
            show={this.state.showModal}
            onHide={() => this.helper_closeModal()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Members that can be linked for the fields
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="custom-panel-body">
                <div className="member-link-modal-container">
                  <div className="member-link-search-group">
                    <StoreContext.Provider value={this.props.detailViewStore}>
                      <ListSearch
                        searchMatrixKey={searchMatrixKey}
                        placeholder={"Filter by Name or Code"}
                      />
                    </StoreContext.Provider>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      margin: "0 0 10px 10px",
                    }}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.showEqualMembers}
                        style={{ margin: 0, verticalAlign: "middle" }}
                        onChange={this.handleShowEqualMembers}
                      />{" "}
                      Only equal members
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.applyFilterOnlyForPrimaryMembers}
                        style={{ margin: 0, verticalAlign: "middle" }}
                        onChange={this.handleApplyFilterOnlyForForeignMembers}
                      />{" "}
                      Apply to left members only
                    </label>
                  </div>
                  <div className="member-link-legend">
                    <span className="ecb-green-c" />
                    <span className="ecb-info-text">
                      The members are matched
                    </span>
                    <span className="ecb-red-c" />
                    <span className="ecb-info-text">
                      The members are not included in the related cube, please
                      consider possible inconsistencies
                    </span>
                  </div>
                  {this.state.isEnumerated ? (
                    <div className="member-link-table-container">
                      <Table hover className="member-link-table">
                        <thead>
                          <tr>
                            <td>
                              <div>
                                <div>
                                  <Link
                                    className="object-name"
                                    to={`/view/${header.primaryFramework.type}/${header.primaryFramework.tid}`}
                                  >
                                    {header.primaryFramework.name ? (
                                      <CellContent
                                        maxLength={60}
                                        content={header.primaryFramework.name}
                                        id={0}
                                      />
                                    ) : (
                                      "->"
                                    )}
                                  </Link>
                                </div>
                                <div>
                                  {this.state.primaryTitle ? (
                                    <CellContent
                                      maxLength={60}
                                      content={this.state.primaryTitle}
                                      id={0}
                                    />
                                  ) : (
                                    "->"
                                  )}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div>
                                <div>
                                  <Link
                                    className="object-name"
                                    to={`/view/${header.foreignFramework.type}/${header.foreignFramework.tid}`}
                                  >
                                    {header.foreignFramework.name ? (
                                      <CellContent
                                        maxLength={60}
                                        content={header.foreignFramework.name}
                                        id={0}
                                      />
                                    ) : (
                                      "->"
                                    )}
                                  </Link>
                                </div>
                                <div>
                                  {this.state.foreignTitle ? (
                                    <CellContent
                                      maxLength={60}
                                      content={this.state.foreignTitle}
                                      id={0}
                                    />
                                  ) : (
                                    "->"
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredEqualMembers &&
                          filteredEqualMembers.length > 0 ? (
                            filteredEqualMembers
                              .sort((a, b) =>
                                a.primaryMember.code.localeCompare(
                                  b.primaryMember.code
                                )
                              )
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <Link
                                        className="object-name"
                                        to={`/view/${item.primaryMember.type}/${item.primaryMember.tid}`}
                                      >
                                        {`${item.primaryMember.name} (${item.primaryMember.code})`}
                                      </Link>
                                    </td>
                                    <td>
                                      <Link
                                        className="object-name color-object-name"
                                        text-color={`${item.foreignMember.isLinked}`}
                                        to={`/view/${item.foreignMember.type}/${item.foreignMember.tid}`}
                                      >
                                        {`${item.foreignMember.name} (${item.foreignMember.code})`}
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td>{"Nothing Found"}</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div>{"These Variables are non-enumerated"}</div>
                  )}
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}
